/**
 * React Query cache namespace for this surface. Mirrors `InspectionAttachments/constants.ts` —
 * the shared surface and the field commit have to agree on the entity key.
 */
export const WORK_ORDER_ATTACHMENTS_ENTITY_KEY = 'work-order-attachments';
/** Locale namespace holding this surface's table copy. */
export const WORK_ORDER_ATTACHMENTS_NS = 'features.work_order_attachments.table';
export const MASS_ACTIONS_NS = 'features.work_order_attachments.mass_actions';
/**
 * Note `tab`, not `table` — a sibling of the table namespace, not a child. Deriving it as
 * `${namespace}.progress_toast` produced a `[missing ...]` string on the Building surface that a
 * green test suite could not see, which is why the shared config takes it explicitly.
 */
export const PROGRESS_TOAST_NS = 'features.work_order_attachments.tab.progress_toast';
export const EDIT_MODAL_ERRORS_NS = 'features.work_order_attachments.edit_modal.errors';
export const UPLOAD_NS = 'features.work_order_attachments.upload';
export const COMMONS_NS = 'features.commons';
/**
 * Row sources, matching `WorkOrders::SupportDocuments::SOURCE_*` exactly. Only `ATTACHMENT` rows
 * are uploaded by a user; the other three are join rows pointing at a Report or a Proposal.
 */
export const SOURCE_ATTACHMENT = 'attachment';
export const SOURCE_REPORT = 'report';
export const SOURCE_INSPECTION_DOCUMENT = 'inspection_document';
export const SOURCE_PROPOSAL_DOCUMENT = 'proposal_document';
/** `remove_kind` values — a delete destroys the row, an unlink only detaches it. */
export const REMOVE_KIND_DELETE = 'delete';
export const REMOVE_KIND_UNLINK = 'unlink';
/** Filter identity for the Source filter. */
export const SOURCE_FILTER_KEY = 'source';
/** `update_action` value `#bulk_update` switches on — matches the controller's constant. */
export const BULK_UPDATE_ACTION_REPORT_OPTIONS = 'report_options';
/** Finalize attribute name — the wire shape the work order presign/finalize endpoints accept. */
export const ATTR_SHOW_ON_REPORT = 'show_on_report';
/**
 * The accepted-type list is NOT duplicated here. It is passed down from the server, which reads
 * `DirectUploads::AttachmentType::WORK_ORDER_CONTENT_TYPES` — itself derived from the model's own
 * `WORK_ORDER_ATTACHMENT_TYPES`. A hand-maintained copy in this file was already wrong on its
 * first draft (it omitted `text/comma-separated-values` and `application/csv`), which is exactly
 * the client/server drift that makes a file pass the picker and then fail at finalize, after the
 * bytes are already in S3.
 *
 * When the prop is absent the file picker simply does not filter; the presign endpoint is the
 * real gate either way, so an unfiltered picker is a worse prompt, never a security hole.
 */
export const WORK_ORDER_ACCEPT_FALLBACK = undefined;
